/*
 * ---------------------------------------------------------------------
 * Content Action Types
 * ---------------------------------------------------------------------
 */
export const SHOW_CONTENT = "SHOW_CONTENT";

export const HIDE_CONTENT = "HIDE_CONTENT";
